import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  .aside-button-icon svg {
    height: 24px;
    width: fit-content;
    color: ${({ theme }) => theme.colors.gray[900]};
  }

  .menu {
    width: 100%;
    text-align: center;
    padding: 13px;

    font-weight: 600;
    font-size: 14px;
    line-height: 18px;

    transition: 0.3s ease;

    &:hover {
      background-color: ${({ theme }) => theme.colors.orange.primary};
      color: ${({ theme }) => theme.colors.white};

      .submenu {
        display: block;
      }
    }

    div {
      font-size: 14px;
    }

    p {
      margin-top: 8px;
    }

    .submenu {
      display: none;

      background: ${({ theme }) => theme.colors.gray[100]};

      box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14),
        0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);

      position: absolute;
      left: 100%;
      top: 0;
      height: inherit;

      list-style: none;

      z-index: 1;
      padding: 8px 0;

      li div {
        font-weight: 500;
        font-size: 14px;
        white-space: nowrap;

        display: flex;
        gap: 8px;
        align-items: center;

        color: ${({ theme }) => theme.colors.gray[600]};
        padding: 8px 12px;

        &:hover {
          background-color: ${({ theme }) => theme.colors.orange.primary};
          color: ${({ theme }) => theme.colors.gray[100]};
        }
      }
    }
  }
  &:hover {
    background-color: ${({ theme }) => theme.colors.orange.primary};
    color: ${({ theme }) => theme.colors.gray[100]};

    svg {
      color: ${({ theme }) => theme.colors.white};
    }
  }

  .active {
    background-color: ${({ theme }) => theme.colors.orange.primary};
    color: ${({ theme }) => theme.colors.white};

    svg {
      color: ${({ theme }) => theme.colors.white};
    }
  }
`;
